module.exports = __webpack_public_path__ + "img/role-75.5034fb1b.svg";